import { render, staticRenderFns } from "./altDashboard.vue?vue&type=template&id=4434fe16&scoped=true&"
import script from "./altDashboard.vue?vue&type=script&lang=js&"
export * from "./altDashboard.vue?vue&type=script&lang=js&"
import style0 from "./altDashboard.vue?vue&type=style&index=0&id=4434fe16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434fe16",
  null
  
)

component.options.__file = "altDashboard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
  VLayout,
  VTextField,
  VTextarea,
})
